<template>
	<button class="sale-item" @click.stop="$emit('openProductModal', item.id)">
		<div class="sale-item__inner">
			<div class="sale-item__name">
				{{ getWeaponName(item.title) }}
			</div>
			<div class="sale-item__top">
				<div class="sale-item__title _md">
					{{ getSkinName(item.title) }}
				</div>
				<div class="sale-item__quality _md">
					({{ getWear(item.title) }})
				</div>
			</div>
			<div class="sale-item__bg _ibg-contain">
				<img src="@/assets/images/bg/yellow-blur.png" />
			</div>
			<div class="sale-item__image _ibg-contain">
				<img :src="imgDomain + item.img_url" />
			</div>
		</div>
		<div class="sale-item__bottom">
			<div class="sale-item__price">
				<div class="sale-item__number _l">
					{{ item.price }} {{ currencySymbol }}
				</div>
				<!--<div class="sale-item__icon _ibg-contain">
					<img src="@/assets/images/icons/coin.svg" />
				</div>-->
			</div>
			<button
				class="sale-item__buy _button-white"
				@click.stop="handleClick(item)"
			>
				{{ $t('Buy') }}
			</button>
		</div>
	</button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'SaleItem',
	data() {
		return {
			imgDomain: '',
		};
	},
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapGetters('cart', ['cartContents']),
		...mapGetters('app', ['currencySymbol']),
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	methods: {
		handleClick(item) {
			if (!this.isAuth) {
				this.$emit('openLoginModal');
				return;
			}

			const itemAlreadyInCart = this.cartContents.some(
				(cartItem) => cartItem.item_id === item.id
			);

			if (itemAlreadyInCart) {
				this.$toast.info(this.$t('This item is already in your cart.'));
				this.$emit('openCartModal');
				return;
			}

			this.$emit('addToCart', item);
			this.$toast.info(this.$t('Item added to your cart.'));
			this.$emit('openCartModal');
		},
		getWeaponName(desc) {
			if (!desc) return '';
			const match = desc.match(/^([^|]+)\|/);
			return match ? match[1].trim() : '';
		},
		getSkinName(desc) {
			if (!desc) return '';
			const match = desc.match(/\|\s*([^()]+)\(/);
			return match ? match[1].trim() : '';
		},
		getWear(desc) {
			if (!desc) return '';
			const match = desc.match(/\(([^)]+)\)/);
			return match ? match[1].trim() : '';
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;
.sale-item {
	background-color: transparent;
	flex: 0 1 33.333%;
	position: relative;
	display: flex;
	flex-direction: column;
	transform: scale(1);

	@media (any-hover: hover) {
		&:hover {
			.sale-item__bg {
				transform: translate(-50%, -50%) scale(1.1);
			}
			.sale-item__image {
				transform: scale(1.1);
			}
		}
	}
	@media (max-width: $md2) {
		flex: 0 1 calc(50% - 10px);
	}
	@media (max-width: $md4) {
		flex: 1 1 100%;
	}
	&__inner {
		flex: 1 1 auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 45, 20);
		}
	}
	&__name {
		font-family: var(--font-family-inter);
		font-size: 12px;
		line-height: 150%;
		color: var(--secondary-color);
		text-align: center;
		&:not(:last-child) {
			margin-bottom: 10px;
		}
	}
	&__top {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		gap: 6px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 23, 15);
		}
	}
	&__title,
	&__quality {
		text-transform: capitalize;
		font-family: var(--font-family-inter);
	}
	&__title {
		font-weight: 700;
	}
	&__quality {
		color: var(--secondary-color);
	}
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) scale(1);
		transition: transform 0.3s ease 0s;
		pointer-events: none;
	}
	&__image {
		max-width: 200px;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		padding-bottom: 29%;
		transform: scale(1);
		transition: transform 0.3s ease 0s;
	}
	&__bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 20px;
		max-width: 80%;
		width: 100%;
		margin: 0 auto;
	}
	&__price {
		display: flex;
		align-items: center;
		@include adaptiveValue('gap', 8, 6);
	}
	&__number {
		font-weight: 900;
		font-family: var(--font-family-inter) !important;
	}
	&__icon {
		@include adaptiveValue('min-width', 23, 20);
		@include adaptiveValue('height', 23, 20);
	}
	&__buy {
	}
}
</style>
